/** Resolve extension visibility and ordering without changing the original array. */
export function resolveAssignmentOptions(options, context, extensions) {
  const resolve = extensions?.getAssignmentOptionState;
  return options
    .map((agent, index) => ({
      agent,
      index,
      state: resolve?.call(extensions, { ...context, agent }) || {},
    }))
    .filter(({ state }) => state.hidden !== true)
    .sort((left, right) => {
      const leftOrder = Number.isFinite(left.state.order)
        ? left.state.order
        : 0;
      const rightOrder = Number.isFinite(right.state.order)
        ? right.state.order
        : 0;
      return leftOrder - rightOrder || left.index - right.index;
    })
    .map(({ agent, state }) => ({ agent, state }));
}
